/* Auto Generated */

export enum ProductServiceType {
	thirdPartySoftware,
	ownSoftware,
	expert,
	training,
}
